module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "unit"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-header"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-name"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.currentPeriod ? _vm.currentPeriod.academic_year : 'NA') + " Academic Year")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.name)), (_vm.level) ? [_vm._v(", " + _vm._s(_vm.level))] : _vm._e()], 2), _vm._v(" "), (_vm.college) ? _c('h4', [_vm._v(_vm._s(_vm.college))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-credits"
  }, [(_vm.unitPeriod && _vm.credits && _vm.$route.name === 'unit-plans') ? _c('span', [_vm._v(_vm._s(_vm.credits) + " Credit Hours")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v("Majors")]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.programName))]), _vm._v(" "), (_vm.concentrationName) ? _c('span', [_vm._v(_vm._s(_vm.concentrationName))]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "unit-plans") ? [_vm._v("/ "), _c('span', [_vm._v("Degree Plan")])] : _vm._e()], 2)]), _vm._v(" "), _c('router-view')], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "background-image"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b8e2e8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Unit.vue
// module id = 1123
// module chunks = 1